<template>
    <div>
        <QScoreCard
            :agent-code="agentCode"
            :filters="filters"
            key="QScoreCardSME"
            title="SME"
            api-endpoint="sme"
            drill-downLabel="Agent Breakdown"
            drill-down-route="Drilldown_SME"
            card-style="production"
            format="Currency"
        >
            Note: APV of total reset application written.
        </QScoreCard>
    </div>
</template>

<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardSME",
    props: ["agentCode", "filters"],
    components: {
        QScoreCard,
    },
}
</script>

<style scoped></style>
